import $ from 'cash-dom';

/**
 * Add js functionality of read-more widget.
 * Use this in couple with a `partials/widgets/read-more` controller. Example:
 * in your twig template render the controller:
   {{ controller('partials/widgets/read-more', {
        'content': 'some content',
        'length': 4,
    }) }}
 * Remember to include this js file to needed page, if it's not included.
 * Also ensure that `scss/widgets/_read-more.scss` is imported.
 */
$(function () {
  const ReadMore = {
    init() {
      const self = this;

      $('.read-more-link, .read-less-link').on('click', function (e) {
        e.preventDefault();

        const $currentLink = $(this);
        const isReadMore = $currentLink.hasClass('read-more-link');

        self._toggleReadMore(
            $currentLink,
            $(this).closest('.read-more-container').find('.visible-content'),
            $(this).closest('.read-more-container').find('.hidden-content'),
        );
      });

      $('.trustpilot-review').on('click', function (e) {
        // to prevent colision with the $('.read-more-link, .read-less-link').on('click').
        if (e.target.tagName === 'I') {
          return;
        }

        const $trustpilotReview = $(this);
        let $currentLink = null;

        $trustpilotReview.find('.read-more-container .content-container > div').each((i, el) => {
          const $el = $(el);

          if (!$el.css('display').includes('none')) {
            $currentLink = $el.find('a').first();
          }
        });

        if ($currentLink && $currentLink.length) {
          self._toggleReadMore(
            $currentLink,
            $trustpilotReview.find('.read-more-container .visible-content'),
            $trustpilotReview.find('.read-more-container .hidden-content'),
          );
        }
      });
    },

    _toggleReadMore($currentLink, $visibleContent, $hiddenContent) {
      const isReadMore = $currentLink.hasClass('read-more-link');

      if (isReadMore) {
        this._open({$visibleContent, $hiddenContent, $currentLink});
      } else {
        this._close({$visibleContent, $hiddenContent, $currentLink});
      }
    },

    _open({$visibleContent, $hiddenContent, $currentLink, forGroup = false}) {
      $visibleContent.hide();
      $hiddenContent.hasClass('flex') ? $hiddenContent.css('display', 'flex') : $hiddenContent.show();
      $currentLink.hide();

      const $readLessLink = $currentLink.closest('.read-more').find('.read-less-link');
      $readLessLink.hasClass('inline') ? $readLessLink.css('display', 'inline') : $readLessLink.show();

      if (!forGroup && $currentLink.data('open-all-group')) {
        this._openForGroup($currentLink.data('open-all-group'));
      }
    },

    _openForGroup(groupdClass) {
      const $readMoreContainers = $('.' + groupdClass);

      $readMoreContainers.each((i, readMoreContainer) => {
        const $readMoreContainer = $(readMoreContainer);

        const $visibleContent = $readMoreContainer.find('.visible-content');
        const $hiddenContent = $readMoreContainer.find('.hidden-content');
        const $currentLink = $readMoreContainer.find('.read-more-link');

        this._open({$visibleContent, $hiddenContent, $currentLink, forGroup: true});
      });
    },

    _close({$visibleContent, $hiddenContent, $currentLink, forGroup = false}) {
      $hiddenContent.hide();
      $visibleContent.show();
      $currentLink.hide();

      const $readMoreLink = $currentLink.closest('.read-more').find('.read-more-link')
      $readMoreLink.hasClass('inline') ? $readMoreLink.css('display', 'inline') : $readMoreLink.show();

      if (!forGroup && $currentLink.data('close-all-group')) {
        this._closeForGroup($currentLink.data('close-all-group'));
      }
    },

    _closeForGroup(groupdClass) {
      const $readMoreContainers = $('.' + groupdClass);

      $readMoreContainers.each((i, readMoreContainer) => {
        const $readMoreContainer = $(readMoreContainer);

        const $visibleContent = $readMoreContainer.find('.visible-content');
        const $hiddenContent = $readMoreContainer.find('.hidden-content');
        const $currentLink = $readMoreContainer.find('.read-less-link');

        this._close({$visibleContent, $hiddenContent, $currentLink, forGroup: true});
      });
    },
  };

  ReadMore.init();
});
